<template>
    <div class="module-afiliasi">
        <SOSlotBase>
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar :page-title="'Masukan OTP'" :type="'close'" @back="back" />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-y-16 p-x-20 content-otp vh-100">
                    <div>
                        <div class="f-16 m-t-16">
                            Kode verifikasi telah dikirim ke nomor {{ phoneNumber }}, <b>Periksa Whatsapp Anda</b> &
                            masukkan kode.
                        </div>
                        <div>
                            <div>
                                <InputOtp :bindButton="'#verifikasi'" @onComplete="setOtpCode" />
                            </div>
                            <div class="f-13 m-t-32 text-center" v-if="isTimer">
                                <span class="f-c-midgrey">Kode akan dikirim ulang dalam </span>
                                <span>
                                    <Countdown
                                        :timeleft="timeleft"
                                        @callbackCountdown="countdownTimeout"
                                        ref="countdown"
                                        @hook:mounted="onMounted"
                                    />
                                </span>
                            </div>
                            <div class="code-otp text" v-if="isLoadingTimer">
                                Kode sedang dikirim ...
                            </div>

                            <div class="f-13 m-t-32 text-center" v-if="isResendOtp">
                                <span class="f-c-midgrey">Belum menerima kode? </span>
                                <a class="f-c-blue" @click="getOTP">Kirim Ulang Kode</a>
                            </div>
                        </div>
                    </div>
                    <div class="btn-save">
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Verifikasi'"
                            :id="`afiliasi-verifikasi-otp`"
                            :loading="isFetching"
                            @action="withdraw"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import InputOtp from "@/component-items/InputOtp";
import Countdown from "@/component-items/Countdown";

import { moduleName } from "../store/state";

const countDownTime = 120;

export default {
    name: "VerifikasiOTP",
    data() {
        return {
            optKode: "",
            isTimer: true,
            isLoadingTimer: false,
            isResendOtp: false,
            timeleft: 0,
            dataLoop: 1,
        };
    },
    mounted() {
        this.timeleft = countDownTime;
        this.dataLoop = 1;
    },
    components: {
        SOSlotBase,
        SOTitleBar,
        SOButton,
        InputOtp,
        Countdown,
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes !== oldRes) {
                if (newRes.success === true) {
                    this.timeleft = countDownTime;
                    this.isResendOtp = false;
                    this.isTimer = true;
                    this.isLoadingTimer = false;
                    this.backToDashboard();
                } else {
                    if (newRes.err) {
                        this.$toast.error(newRes.err);
                    }
                }
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            detailOwner: "detailOwner",
            cashWithdraw: "cashWithdraw",
            response: "getResponse",
            isFetching: "isFecthing",
        }),
        phoneNumber() {
            return this.detailOwner.telp;
        },
    },
    methods: {
        ...mapActions({
            doWithdraw: `${moduleName}/doWithdraw`,
            sendOTP: `${moduleName}/sendOTP`,
            setResponse: `${moduleName}/setResponse`,
        }),
        back() {
            this.$router.push({ name: "afiliasi.dashboard.withdraw" });
        },
        backToDashboard() {
            this.$router.push({ name: "afiliasi.dashboard" });
        },
        onMounted() {
            if (this.dataLoop > 1) {
                this.$refs.countdown.run(this.timeleft);
            }
        },
        withdraw() {
            this.doWithdraw({ amount: this.cashWithdraw, otp: this.optKode });
        },
        async getOTP() {
            this.isResendOtp = false;
            this.isTimer = false;
            this.isLoadingTimer = true;

            this.dataLoop += 1;

            await this.setResponse({});
            await this.sendOTP(this.phoneNumber);
        },
        setOtpCode(otp) {
            this.optKode = otp;
            this.withdraw();
        },
        countdownTimeout() {
            this.timeleft = 0;

            if (this.dataLoop === 3) {
                // do some thing when req_opt > 2
            }

            this.isResendOtp = true;
            this.isTimer = false;
            this.isLoadingTimer = false;
        },
    },
};
</script>

<style scoped>
.content-otp {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    position: fixed;
}

.btn-save {
    align-self: end;
    padding-bottom: 45px;
}
</style>
